import { useEffect, useState } from 'react';
import { getNowPlayingMovie } from '../../../util/apis/MovieAPI';
import { getPlayingThisWeekTV } from '../../../util/apis/TvAPI';
import { fetchMovies, fetchTvShows } from '../../../util/apis/Ourapi';
import Button from '../../Button';

export default function WatchTab() {
  const [content, setContent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Try fetching from Ourapi first
        const movieData = await fetchMovies();
        const tvData = await fetchTvShows();

        const isMovieValid =
          Array.isArray(movieData?.result) && movieData.result.length > 0;
        const isTvValid =
          Array.isArray(tvData?.result) && tvData.result.length > 0;

        console.log(
          'Movies valid:',
          isMovieValid,
          '| TV shows valid:',
          isTvValid,
        );

        if (isMovieValid && isTvValid) {
          const movies = movieData.result.slice(0, 5);
          const shows = tvData.result.slice(0, 5);
          const mergedArray = movies.concat(shows);
          setContent(mergedArray);
        } else {
          // Fallback to original TMDB APIs if Ourapi is not valid
          const [fallbackMovieData, fallbackTvData] = await Promise.all([
            getNowPlayingMovie.get(true),
            getPlayingThisWeekTV.get(true),
          ]);

          const movies = fallbackMovieData.results.slice(0, 5);
          const shows = fallbackTvData.results.slice(0, 5);
          const mergedArray = movies.concat(shows);
          setContent(mergedArray);
        }
      } catch (error) {
        console.error(
          'Error occurred while fetching Ourapi, trying fallback:',
          error,
        );
        try {
          const [fallbackMovieData, fallbackTvData] = await Promise.all([
            getNowPlayingMovie.get(true),
            getPlayingThisWeekTV.get(true),
          ]);

          const movies = fallbackMovieData.results.slice(0, 5);
          const shows = fallbackTvData.results.slice(0, 5);
          const mergedArray = movies.concat(shows);
          setContent(mergedArray);
        } catch (fallbackError) {
          console.error('Fallback APIs also failed:', fallbackError);
        }
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="grid place-items-center  lg:grid-cols-4 md:grid-cols-3  grid-cols-2 gap-y-2 gap-x-3 px-4 md:px-20 lg:px-40 2xl:grid-cols-5">
        {content.map((item, id) => (
          <a
            href={item.title ? `/rate/movie/${item.id}` : `/rate/tv/${item.id}`}
            key={id}
            className="relative mb-2 lg:w-64 rounded-xl overflow-hidden group"
          >
            <div className="relative">
              <img
                src={`https://image.tmdb.org/t/p/original/${item.poster_path}`}
                className="w-full rounded-xl border-2 aspect-poster group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/10 group-hover:bg-black/30 transition duration-300 rounded-xl"></div>
              <div className="absolute bottom-0 w-full text-white bg-black/10 px-3 py-2 text-center text-sm font-semibold group-hover:bg-black/80 transition duration-300">
                {item.title ? item.title : item.name}
              </div>
            </div>
          </a>
        ))}
      </div>

      <div className="flex justify-center py-5">
        <a href="/advance-search/all">
          <Button variant="button" type="button">
            Find More
          </Button>
        </a>
      </div>
    </>
  );
}
